import React from 'react';

/* sidebar: the grey left-hand column (filters, navigation).
 * aside:   a white right-hand column that extends the page itself — e.g. the
 *          trader page's notes/calls/meetings. Drops below the page on mobile. */
const PageShell = ({ sidebar, aside, wrap = true, fluid, children }) => {
    const isFluid = fluid ?? !!(sidebar || aside);
    return (
        <>
            {sidebar ? <aside className="dash-side">{sidebar}</aside> : null}
            <main className="dash-main">
                {wrap ? (
                    <div className={`wrap${isFluid ? ' wrap-fluid' : ''}`}>
                        {children}
                    </div>
                ) : (
                    children
                )}
            </main>
            {aside ? <aside className="dash-aside">{aside}</aside> : null}
        </>
    );
};

export default PageShell;
